<template>
    <div class="totals-container">
        <GekkoButton 
            @click="switchTotalsFormat()" 
            :text="totalsFormatButtonText"
            :icon="totalsFormatButtonIcon"
            variant="link text-blue"
            size="sm"
            class="px-0"
        />
        <TotalAmountsHour :num-format="totalsFormat"/>
    </div>
</template>

<script>
import GekkoButton from "@/components/GekkoButton";
import TotalAmountsHour from "@/components/hours/TotalAmountsHour.vue";
import { mapGetters } from "vuex";

export default {
    name: "HourTotalsContainer",
    components: {GekkoButton, TotalAmountsHour},
    data() {
        return {
            totalsFormat: "hours",
            totalsFormatButtonText: this.$gettext('display in decimal format'),
            totalsFormatButtonIcon: "fa fa-quote-right",
        }
    },
    computed: {
        ...mapGetters ({ 
            displayFormat: "hourStore/getDisplayFormat"
        })
    },
    created() {
        this.totalsFormat = this.$cookies.get(`hoursTotalsFormat-${window.company_id}`);

        if (this.totalsFormat === 'hours') {
            this.totalsFormatButtonText = this.$gettext('display in decimal format');
            this.totalsFormatButtonIcon = "fa fa-quote-right";
        } else {
            this.totalsFormatButtonText = this.$gettext('display in hours format');
            this.totalsFormatButtonIcon = "fa fa-clock";
        }
    },
    methods: {
        switchTotalsFormat() {
            let filterCookieName = `hoursTotalsFormat-${window.company_id}`;
            var d1 = new Date (), expire = new Date ( d1 );
            expire.setMinutes ( d1.getMinutes() + 60 * 12 );

            if (this.totalsFormat === 'hours') {
                this.totalsFormat = "decimal";
                this.totalsFormatButtonText = this.$gettext('display in hours format');
                this.totalsFormatButtonIcon = "fa fa-clock";

                this.$store.commit("hourStore/SET_HOURS_TOTALS_FORMAT", "decimal");
                this.$cookies.set(filterCookieName, "decimal", expire, '/');
            } else {
                this.totalsFormat = "hours";
                this.totalsFormatButtonText = this.$gettext('display in decimal format');
                this.totalsFormatButtonIcon = "fa fa-quote-right";

                this.$store.commit("hourStore/SET_HOURS_TOTALS_FORMAT", "hours");
                this.$cookies.set(filterCookieName, "hours", expire, '/');
            }
        }
    }
}
</script>

<style scoped>
.totals-container {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}
</style>